import React, { useEffect, useRef } from 'react';
import { Toaster } from 'react-hot-toast'; 
import LogRocket from 'logrocket';
import Snowfall from 'react-snowfall';
import { useSelector } from 'react-redux';
import trackOne from '../../components/music/music1.mp3';
import trackTwo from '../../components/music/music2.mp3';
import trackThree from '../../components/music/music3.mp3';
import trackFour from '../../components/music/music4.mp3';
import SantaAnimation from '../../components/holiday/SantaAnimation';

const HOLIDAY_TRACKS = [trackOne, trackTwo, trackThree, trackFour];

// Import custom components
import MainRouter from '../../routers/routes';

// Initialize LogRocket once (avoid double-init in StrictMode)
function useLogRocket() {
  useEffect(() => {
    if (!window.__LOGROCKET_INIT__) {
      LogRocket.init("xfdqze/pm-log");
      LogRocket.identify(
        "App",
        window.location.href.includes("lessons") ? "Lessons Learned" : "Roster"
      );
      window.__LOGROCKET_INIT__ = true;
    }
  }, []);
}


export default function AppContainer() {
  // useLogRocket();
  const isHolidayMode = useSelector((state) => state.global.isHolidayMode);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!isHolidayMode) {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current = null;
      }
      return undefined;
    }

    const randomTrack =
      HOLIDAY_TRACKS[Math.floor(Math.random() * HOLIDAY_TRACKS.length)];
    const audio = new Audio(randomTrack);
    audio.loop = true;
    audio.volume = 0.3;
    audioRef.current = audio;
    const playPromise = audio.play();

    if (playPromise !== undefined) {
      playPromise.catch((err) =>
        console.warn('Holiday music failed to start automatically.', err)
      );
    }

    return () => {
      audio.pause();
      audio.currentTime = 0;
      audioRef.current = null;
    };
  }, [isHolidayMode]);

  return (
    <>
      {isHolidayMode && (
        <>
          <Snowfall
            color="#ffffff"
            snowflakeCount={360}
            style={{
              position: 'fixed',
              width: '100vw',
              height: '100vh',
              pointerEvents: 'none',
              top: 0,
              left: 0,
              zIndex: 9999,
            }}
          />
          <SantaAnimation minTime={10} maxTime={30} size={260} />
        </>
      )}
      <Toaster position="top-right" reverseOrder={false} />
      <MainRouter />
    </>
  );
}
